module.exports = __webpack_public_path__ + "public/static/loginBigImage.svg?f909a056";